import { createContext } from "react";
import { GLOBAL_CONTEXT } from "./types";

const Context = createContext<GLOBAL_CONTEXT>(undefined as any);

export default Context;
